export const columns = [
  {
    title: 'Departament',
    field: 'genericDepartment',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Nume',
    field: 'fullName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Functie',
    field: 'jobTitle',
    align: 'left',
    collapsible: true,
    type: 'string'
  }
]
